import React from "react";

import cx from "classnames";

import { Text } from "../Text";

import styles from "./Callout.scss";

export type CalloutVariant = "information" | "error" | "success";

export interface CalloutProps {
  /** The text inside the callout */
  text: React.ReactElement | string;
  /** Changes the background and border color */
  variant?: CalloutVariant;
  /** Used for testing */
  testid?: string;
  /** Whether to remove margin from the callout */
  noMargin?: boolean;
}

function getVariantClass(variant: CalloutVariant) {
  switch (variant) {
    case "success":
      return { color: styles.systemSuccessDark, className: styles.success };
    case "error":
      return { color: styles.systemWarningDark, className: styles.error };
    default:
      return { color: styles.systemBlue, className: styles.information };
  }
}

/**
 * A callout. Typically used to get attention from users.
 */
export function Callout({
  text,
  variant = "information",
  testid = "callout-container",
  noMargin = false,
}: CalloutProps) {
  const { color, className } = getVariantClass(variant);
  const applyClass = cx(styles.wrapper, className, {
    [styles.noMargin]: noMargin,
  });
  return (
    <div data-testid={testid} className={applyClass}>
      <Text
        color={color}
        data-testid="callout-text"
        paragraph
        size="paragraphXsmall"
      >
        {text}
      </Text>
    </div>
  );
}
